// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14a88899","667":"280be97a"}[chunkId] + ".chunk.js";
};